<template>
  <ul class="app-navbar-list">
    <li class="app-navbar-item" v-for="item in navs" :key="item.path">
      <router-link :to="{ name: item.name }">{{ item.label }}</router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AppNavbar',
  data () {
    return {
      navs: [
        {
          label: '推广首页',
          name: 'Home'
        },
        {
          label: '智能搜索',
          name: 'Workbench'
        },
        {
          label: '云官网',
          name: 'Site'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.app-navbar-list {
  padding-left: 0;
  margin: 0 0 0 64px;
  list-style: none;
}
.app-navbar-item {
  display: inline-block;
  padding: 0 15px;

  a {
    display: block;
    position: relative;

    &.router-link-active {
      &:after {
        content: " ";
        position: absolute;
        left: 50%;
        bottom: -8px;
        display: block;
        width: 20px;
        height: 2px;
        margin-left: -10px;
        border-radius: 2px;
        background-color: #fff;
      }
    }
  }
}
</style>
